import React, { useState } from "react";
import { Navbar, Nav } from "react-bootstrap";
import { Link, useLocation } from 'react-router-dom';
import HomeIcon from "@material-ui/icons/Home";
import SearchIcon from "@material-ui/icons/Search";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import BookmarkBorderIcon from "@material-ui/icons/BookmarkBorder";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import Brightness4Icon from '@material-ui/icons/Brightness4'; // Import the dark mode icon
import Brightness7Icon from '@material-ui/icons/Brightness7'; // Import the light mode icon
import './header.css';
import logo from "../../img.png";
import logo1 from "./whitelogo.png";
import { getAuth, signOut } from "firebase/auth";

const Header = ({ toggleTheme }) => {
    const auth = getAuth();
    const user = auth.currentUser;
    const [showOptions, setShowOptions] = useState(false);
    const location = useLocation();
    const [isDarkMode, setIsDarkMode] = useState(true);

    const handleToggle = () => {
        setShowOptions(!showOptions);
    };

    const handleThemeToggle = () => {
        setIsDarkMode(prevMode => !prevMode);
        toggleTheme(); // Call the toggleTheme function to toggle the theme
    };

    const handleLogout = async () => {
        try {
            await signOut(auth);
            // Handle redirection after logout if needed
        } catch (error) {
            console.error("Error signing out", error);
        }
    };

    const isLoginPage = location.pathname === '/login';

    return (
        <Navbar expand="md" className={`header ${isDarkMode ? 'dark-mode' : ''}`} style={{ backgroundColor: isDarkMode ? '#333' : '#f8f9fa' }}>
            <div className="col">
                {user ? (
                    <Navbar.Brand as={Link} to="/" className="logo-container">
                        <img src={isDarkMode ? logo1 : logo} alt="Logo" className="logo3"  />
                    </Navbar.Brand>
                ) : (
                    <div className="logo-container">
                        <img src={isDarkMode ? logo1 : logo} alt="Logo" className="logo3"  />
                    </div>
                )}
            </div>

            <button className="navbar-toggler navbar-toggler-sm" type="button" onClick={handleToggle}>
                <span className="navbar-toggler-icon"></span>
            </button>

            <div className={`collapse navbar-collapse ${showOptions ? 'show' : ''}`} id="navbarNav"  style={{marginRight:"10%"}}>
                <Nav className="ml-md-auto" >
                    {/*{(location.pathname === '/signup' || location.pathname === '/login') && (*/}
                    {/*    <h6 style={{ color: isDarkMode ? '#fff' : '#000', textAlign:"center",marginRight:"28%",display:"contents", fontWeight: "bold", fontFamily: "cursive" }}>Discover International Scholarships and Opportunities</h6>*/}
                    {/*)}*/}

                    {user && (
                        <>
                            <Link to="/" className={`nav-link AJ ${isDarkMode ? 'text-light' : 'text-dark'}`} onClick={() => setShowOptions(false)}><HomeIcon /> Home</Link>
                            <Link to="/search" className={`nav-link AJ ${isDarkMode ? 'text-light' : 'text-dark'}`} onClick={() => setShowOptions(false)}><SearchIcon /> Search</Link>
                            <Link to="/bookmark" className={`nav-link AJ ${isDarkMode ? 'text-light' : 'text-dark'}`} onClick={() => setShowOptions(false)}><BookmarkBorderIcon /> Bookmark</Link>
                            <Link to="/contact" className={`nav-link AJ ${isDarkMode ? 'text-light' : 'text-dark'}`} onClick={() => setShowOptions(false)}><MailOutlineIcon /> Contact</Link>
                            <Link to="/aboutus" className={`nav-link AJ ${isDarkMode ? 'text-light' : 'text-dark'}`} onClick={() => setShowOptions(false)}><MoreHorizIcon /> About Us</Link>
                            <Link to="/login" className={`nav-link AJ ${isDarkMode ? 'text-light' : 'text-dark'}`} onClick={() => { handleLogout(); setShowOptions(false); }}><ExitToAppIcon /> Logout</Link>
                        </>
                    )}
                </Nav>
            </div>

            <div className="toggle-container">
                {isDarkMode ? (
                    <Brightness7Icon className="toggle-button" style={{ fontSize: '40px' }} onClick={handleThemeToggle} />
                ) : (
                    <Brightness4Icon className="toggle-button" style={{ fontSize: '40px' }} onClick={handleThemeToggle} />
                )}
            </div>
        </Navbar>

    );
}

export default Header;
